import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import ActionBar from "../../common/ActionBar/ActionBar";
import { BlockIcon } from "../../common/Icons";
import { Button } from "../../common/VFX-UI";

//App
import useComponentGeneralStyles from "../../styles";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { RoleViewProps } from "../../../types/role";
import { RoleContext } from "./RoleContainer";

const RoleView = (props: RoleViewProps) => {
  const { onClose, editAction, toggleDeactivateHandler } = props;
  const roleContext = useContext(RoleContext);
  const generalStyles = useComponentGeneralStyles();

  const role = roleContext?.data;

  return (
    <FormBackGround>
      <FormHeader
        title="View Role"
        onClose={onClose}
        editActionHandler={editAction}
      />
      <Container>
        <DisplayData text="Name" importedData={role?.name}></DisplayData>
        {role?.id && role?.id !== EMPTY_GUID && (
          <Container>
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          </Container>
        )}
      </Container>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default RoleView;
